import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getDepartments } from '../api/Index'
import './Departments.css'
import PageTitle from '../components/UI/PageTitle'
import Separator from '../components/UI/Separator'

const Departments = () => {
  const navigate = useNavigate();
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDepartments = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await getDepartments();
        setDepartments(response.data);
      } catch (err) {
        setError(err.message);
        console.error('Error fetching departments:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchDepartments();
  }, []);

  const handleDepartmentClick = (departmentId) => {
    navigate(`/department-details?id=${departmentId}`);
  };

  const DepartmentCard = ({ department }) => {
    const formatDate = (dateString) => {
      if (!dateString) return 'Not available';
      return new Date(dateString).toLocaleDateString();
    };

    const formatHead = (head) => {
      if (!head) return 'No head assigned';
      if (typeof head === 'string') return head;
      return head.name || 'Unknown';
    };

    const formatMembers = (members) => {
      if (!members || members.length === 0) return 'No members';
      if (Array.isArray(members)) {
        return `${members.length} member${members.length !== 1 ? 's' : ''}`;
      }
      return 'Unknown';
    };

    return (
      <div 
        className="department-profile-container"
        onClick={() => handleDepartmentClick(department._id || department.id)}
        style={{cursor: 'pointer'}}
      >
        <div className="department-details">
          <h3>{department.name}</h3>
          <div className="department-info">
            <p>Head: {formatHead(department.head)}</p>
            <p>Members: {formatMembers(department.members)}</p>
            <p>Budget: {department.budget ? `$${department.budget.toLocaleString()}` : 'Not specified'}</p>
            <p>Created At: {formatDate(department.createdAt)}</p>
          </div>
        </div>
        <div className="department-status">
          Active
        </div>
      </div>
    );
  };


  if (loading) {
    return (
      <div>
        <PageTitle title="Departments" />
        <div>Loading departments...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <PageTitle title="Departments" />
        <div style={{color: 'red'}}>Error: {error}</div>
      </div>
    );
  }

  return (
    <div>
      <PageTitle title="Departments" />
      <div>
        {departments.length === 0 ? (
          <div>No departments found.</div>
        ) : (
          departments.map((department) => (
            <>
              <DepartmentCard key={department._id || department.id} department={department} />
              <Separator />
            </>
          ))
        )}
      </div>
    </div>
  )
}

export default Departments